import React from "react";
import "./style.css";
import { Col, Container, Row } from "react-bootstrap";
import InstagramIcon from "../../Images/Instagram_icon.png";
import WhatsAppIcon from "../../Images/WhatsApp_icon.png";

const Footer = () => {
  return (
    <footer>
      <Container>
        <div className="logo">
          <ion-icon name="bag"></ion-icon>
          <h1>Important Note</h1>
        </div>
        <p>
          Currently online payment is not enabled due to technical issues. Will
          be updated shortly... <br /> To avail best offers please contact Ph:
          +91 9148114488
        </p>

        <h2>Contact Us</h2>
        <ul>
          <li>Email: jeevantheone144@gmail.com</li>
          <li>Phone: +91 9148114488</li>
          <li>
            Links:{" "}
            <a
              href="https://www.instagram.com/mante_cellular"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginRight: "10px" }}
            >
              <img
                src={InstagramIcon}
                alt="Instagram"
                style={{ width: "24px", height: "24px", verticalAlign: "middle" }}
              />
            </a>
            <a
              href="https://wa.me/919886997761"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={WhatsAppIcon}
                alt="WhatsApp"
                style={{ width: "24px", height: "24px", verticalAlign: "middle" }}
              />
            </a>
          </li>
        </ul>
      </Container>
    </footer>
  );
};

export default Footer;
